import { useEffect } from "react";
import Footer from "./Footer";
import useBlogs from "../../services/LandingPage/useBlogs";
import { useParams } from "react-router-dom";

const productURLMapping = {
  Anlook: "https://anlook.com/blog",
  BillPunch: "https://billpunch.com/blog",
};

const Author = () => {
  const { author } = useParams();

  const { authorBlogs, authorData, fetchBlogsByAuthor, loading } = useBlogs();

  useEffect(() => {
    if (author) {
      fetchBlogsByAuthor(author);
    }
  }, [author]);

  return (
    <>
      <div className="bg-gray-50 min-h-screen">
        <div className="max-w-7xl mx-auto px-4 py-12">
          {/* ===== Author Header Section ===== */}
          <div className="bg-white rounded-2xl shadow-sm p-8 mb-12">
            {authorData ? (
              <div className="flex flex-col md:flex-row items-center gap-8">
                <div className="w-40 h-40 rounded-full overflow-hidden border-4 border-gray-100 shadow">
                  <img
                    src={authorData.image}
                    alt={authorData.name}
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="text-center md:text-left">
                  <h1 className="text-3xl font-bold text-gray-800">
                    {authorData.name}
                  </h1>
                  <p className="text-gray-500 mt-2">
                    Articles written by {authorData.name}
                  </p>
                  <p className="text-sm text-gray-400 mt-1">
                    {authorBlogs.length} Published Posts
                  </p>
                </div>
              </div>
            ) : (
              <p className="text-center text-gray-500">Loading author...</p>
            )}
          </div>

          {/* ===== Blog Grid Section ===== */}
          {loading ? (
            <p className="text-center text-gray-500">Loading blogs...</p>
          ) : authorBlogs.length > 0 ? (
            <>
              <h2 className="text-2xl font-semibold text-gray-800 mb-6">
                Latest Articles
              </h2>

              <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
                {authorBlogs.map((post) => (
                  <div
                    key={post.post_id}
                    className="bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 flex flex-col overflow-hidden"
                  >
                    {/* Image */}
                    <div className="aspect-video overflow-hidden">
                      <img
                        src={post.post_featured_image}
                        alt={post.post_featured_image_alt}
                        className="w-full h-full object-cover hover:scale-105 transition duration-500"
                      />
                    </div>

                    {/* Content */}
                    <div className="p-5 flex flex-col flex-grow">
                      <h3 className="text-lg font-semibold text-gray-800 line-clamp-2 mb-3">
                        {post.post_title}
                      </h3>

                      <p className="text-sm text-gray-600 line-clamp-3 flex-grow">
                        {post.post_excerpt}
                      </p>

                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={
                          productURLMapping[post.product_name]
                            ? `${productURLMapping[post.product_name]}/${post.post_slug}`
                            : `/blogs/${post.post_slug}`
                        }
                        className="text-green-600 font-medium mt-4 hover:underline"
                      >
                        Read More →
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <p className="text-center text-gray-500">
              No blogs found for this author.
            </p>
          )}
        </div>

        <Footer />
      </div>

      <Footer />
    </>
  );
};

export default Author;
